// removed by extract-text-webpack-plugin
module.exports = {"contact":"_1mxQ","wrapper":"_3-oz","title":"_2jNP","listItem":"_3U9R","contactLink":"_1UYX","address":"_1zwN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/CompanyInfo/styles.scss
// module id = 431
// module chunks = 0